// extracted by mini-css-extract-plugin
export default {"columns":"GheIxTablesTab_columns__w2xGX","column":"GheIxTablesTab_column__VyJ9A"};